import { HttpClient } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { OfficeSelectorService } from "../../../../common/officeSelector/officeSelector.service";
import "../../../../util/string";
import { KpiServiceError, KpiServiceErrorType } from "../../../../dashboardCommon/services/kpiServiceError";
import { ContractsKpiCfg, ContractsKpiCfgService } from "./contractsKpiCfg.service";
import { ContractsKpiService, Range } from "./contractsKpiService";
import { DateRange } from "./dateRange";
import { ApigeeService } from "src/app/auth/apigee/apigee.service";

export class ContractDetail {
    public type: string;
    public unitId: string;
    public unitName: string;
    public nif: string;
    public name: string;
    public beginDate: Date;
    public endDate: Date;
    public workername: string;
    public workerEmail: string;
    public workerPhone: string;
    public clientFiscalName: string;
    public workerNif: string;
    public workerId: number;
    public isWeb: string;
}

export class UnsignedContractsDetailServiceData {
    public contracts: ContractDetail[];
    public updateTimestamp: Date;
}

export abstract class UnsignedContractsDetailService extends ContractsKpiService<UnsignedContractsDetailServiceData> {

    protected abstract getRange(): DateRange;

    constructor(private serviceCfg: ContractsKpiCfgService, private apigeeService: ApigeeService,
        private officeSelectorService: OfficeSelectorService, private httpClient: HttpClient, injector: Injector) {
        super(injector);
    }

    protected getDates(): Range {
        return this.getDateRange(this.getRange());
    }

    protected async update(): Promise<UnsignedContractsDetailServiceData> {
        if (this.apigeeService.apiToken && this.officeSelectorService.selectedOffice) {
            let result: UnsignedContractsDetailServiceData = null;
            try {

                let cfg: ContractsKpiCfg = this.serviceCfg.getCfg();
                let { begin, end } = this.getDates();
                let url = cfg.unsignedContracts.detailEndpointPattern.format(this.officeSelectorService.selectedOffice.id, begin, end);
                result = await this.httpClient.get<UnsignedContractsDetailServiceData>(url).toPromise();
            } catch (error) {
                let errorMessage = error.error ? error.error.message || error.error.errorMessage : error.message;
                throw new KpiServiceError(KpiServiceErrorType.requestError, "KpiServiceError-{0}-{1}".format(this.getClassName(), errorMessage));
            }

            if (result == null) throw new KpiServiceError(KpiServiceErrorType.noData, "KpiServiceError-{0}-No data".format(this.getClassName()));
            else return result;
        } else {
            throw new KpiServiceError(KpiServiceErrorType.missingInputParameters, "KpiServiceError-{0}-Missing input parameters".format(this.getClassName()));
        }
    }
}

@Injectable()
export class PastUnsignedContractsDetailService extends UnsignedContractsDetailService {
    public getClassName() { return "PastUnsignedContractsDetailService"; }

    constructor(serviceCfg: ContractsKpiCfgService, apigeeService: ApigeeService,
        officeSelectorService: OfficeSelectorService, httpClient: HttpClient, injector: Injector) {
        super(serviceCfg, apigeeService, officeSelectorService, httpClient, injector);
    }

    protected getRange(): DateRange { return DateRange.Past; }
}

@Injectable()
export class InmediateUnsignedContractsDetailService extends UnsignedContractsDetailService {
    public getClassName() { return "InmediateUnsignedContractsDetailService"; }

    constructor(serviceCfg: ContractsKpiCfgService, apigeeService: ApigeeService,
        officeSelectorService: OfficeSelectorService, httpClient: HttpClient, injector: Injector) {
        super(serviceCfg, apigeeService, officeSelectorService, httpClient, injector);
    }

    protected getRange(): DateRange { return DateRange.TodayTomorrow; }
}

@Injectable()
export class ForecastedUnsignedContractsDetailService extends UnsignedContractsDetailService {
    public getClassName() { return "ForecastedUnsignedContractsDetailService"; }

    constructor(serviceCfg: ContractsKpiCfgService, apigeeService: ApigeeService,
        officeSelectorService: OfficeSelectorService, httpClient: HttpClient, injector: Injector) {
        super(serviceCfg, apigeeService, officeSelectorService, httpClient, injector);
    }

    protected getRange(): DateRange { return DateRange.Forecast; }
}

export class TodayTomorrowUnsignedContractsDetailService extends UnsignedContractsDetailService {
    public getClassName() { return "TodayTomorrowUnsignedContractsDetailService"; }

    constructor(serviceCfg: ContractsKpiCfgService, apigeeService: ApigeeService,
        officeSelectorService: OfficeSelectorService, httpClient: HttpClient, injector: Injector) {
        super(serviceCfg, apigeeService, officeSelectorService, httpClient, injector);
    }

    protected getRange(): DateRange { return DateRange.TodayTomorrow; }
}
